"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var preact_transitioning_1 = require("preact-transitioning");
var config_1 = require("./config");
function AddRemoveExample() {
    var _a = (0, hooks_1.useState)([Math.random()]), items = _a[0], setItems = _a[1];
    var addItem = function () {
        setItems(function (prevItems) { return __spreadArray(__spreadArray([], prevItems, true), [Math.random()], false); });
    };
    var removeFirstItem = function () {
        setItems(function (_a) {
            var nextGroupItems = _a.slice(1);
            return nextGroupItems;
        });
    };
    var removeItem = function (index) {
        setItems(function (prevItems) { return __spreadArray(__spreadArray([], prevItems.slice(0, index), true), prevItems.slice(index + 1), true); });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container", children: [(0, jsx_runtime_1.jsx)("button", { onClick: addItem, type: "button", children: "Add item" }), ' ', (0, jsx_runtime_1.jsx)("button", { onClick: removeFirstItem, type: "button", children: "Remove first item" }), (0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsx)(preact_transitioning_1.TransitionGroup, { duration: config_1.DURATION, children: items.map(function (groupItem, index) { return ((0, jsx_runtime_1.jsx)(preact_transitioning_1.CSSTransition, { classNames: "fade", children: (0, jsx_runtime_1.jsxs)("button", { type: "button", className: "item", onClick: function () { return removeItem(index); }, children: ["\u00D7 ", groupItem] }) }, groupItem)); }) })] }));
}
exports.default = AddRemoveExample;
